import type { UrgencySignalsProps } from '@eventbrite/urgency-signals';
import {
    OnlyWhenUrgencySignalsEnabled,
    UrgencyMessages,
    UrgencySignalsProvider,
} from '@eventbrite/urgency-signals';
import React, { FunctionComponent } from 'react';
import './UrgencySignalsNode.scss';

export const UrgencySignalsNode: FunctionComponent<{
    urgencySignals: UrgencySignalsProps;
}> = ({ urgencySignals }) => (
    <div
        className="checkout-urgency-signals eds-fx--fade-in"
        data-spec="checkout-urgency-signal"
        data-testid="checkout-urgency-signal"
    >
        <UrgencySignalsProvider urgencySignals={urgencySignals}>
            <OnlyWhenUrgencySignalsEnabled>
                <UrgencyMessages />
            </OnlyWhenUrgencySignalsEnabled>
        </UrgencySignalsProvider>
    </div>
);
